
import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, Input,
  Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({ 
  selector: 'app-combo-modal',
    templateUrl: './combo-modal.component.html',
    styleUrls: ['./combo-modal.component.scss']
})
export class ComboModalComponent implements OnInit, OnDestroy  {


  @ViewChild("comboModal", { static: false }) ComboModal: TemplateRef<any>;

  public closeResult: string;
  public modalOpen: boolean = false; 

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router, private modalService: NgbModal,
    ) { 
      console.log('asdsad');
    }

  ngOnInit(): void {
  }


  openModal() {
    this.modalOpen = true;
    if (isPlatformBrowser(this.platformId)) { // For SSR 
      this.modalService.open(this.ComboModal, { 
        ariaLabelledBy: 'modal-basic-title',
        size:'lg',
        centered: true,
        windowClass: 'Quickview' 
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) { 
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }  

  ngOnDestroy() {
    if(this.modalOpen){
      this.modalService.dismissAll();
    }
  }

}

